<template>
  <div class="ui fluid container">
    <div :class="cssClass">
      <div
        class="ui column"
        v-for="(player, playerId) in players"
        :key="playerId"
      >
        <div
          class="ui center aligned padded segment"
          :class="{ disabled: isDisabled(playerId) }"
        >
          <div class="ui huge statistic">
            <div class="value">{{ player.score }}</div>
            <div class="label">{{ player.name | smartTruncate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { nrToWord } from '../../filters';
import { find as _find } from 'lodash';
import { ROUNDS } from '@/config';

export default {
  name: 'scoreboard-horizontal',
  computed: {
    ...mapGetters(['players', 'nrOfPlayers']),
    cssClass() {
      return `ui ${nrToWord(this.nrOfPlayers)} column stretched stackable grid`;
    }
  },
  methods: {
    isDisabled(playerId) {
      return (
        this.$store.state.game.currentRound === 5 &&
        !_find(
          this.$store.getters[`${ROUNDS[5].slug}/playersToGoToFinale`],
          p => {
            return playerId === p.id;
          }
        )
      );
    }
  }
};
</script>

<style scoped>
.ui.statistic > .value {
  font-size: 8rem !important;
}
</style>
